'use client'

import { cloneElement, type JSX } from 'react'

import { sendGenericEvent } from '../../events/generics/sendGenericEvent'

type EventElementProps = {
	children: JSX.Element
	eventName: string
	eventData?: Record<string, string | number>
}

export const EventElement = ({
	children,
	eventData = {},
	eventName,
}: EventElementProps) => {
	const handleClick = () => {
		sendGenericEvent(eventName, eventData)
	}

	return cloneElement(children, {
		onClick: handleClick,
	})
}
